import React, { useState } from 'react'
import FetchWeather from './api/FetchWeather'

import './App.css'

const App = () => {
  const [query, setQuery] = useState('')
  const [weatherData, setWeatherData] = useState({})

  const Search = async (e) => {
    if (e.key === 'Enter') {
      const data = await FetchWeather(query)
      console.log(data)
      setWeatherData(data)
    }
  }

  return (
    <div className='main-container'>
      <input
        className='search'
        type='text'
        placeholder='Enter City Name'
        autoFocus={true}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={Search}
      />
      {weatherData.main && (
        <div className='city'>
          <h3 className='city-name'>
            <span>{weatherData.name}</span>
            <sup>{weatherData.sys.country}</sup>
          </h3>
          <div className='city-temp'>
            {Math.round(weatherData.main.temp)}
            <sup>&deg;c</sup>
          </div>
          <div className='info'>
            <img
              src={`https://openweathermap.org/img/wn/${weatherData.weather[0].icon}@2x.png`}
              alt={weatherData.weather[0].description.toUpperCase()}
            />
            <p>{weatherData.weather[0].description}</p>
          </div>
        </div>
      )}
    </div>
  )
}

export default App
